import api from "./api";

const chatService = {
  // Users (for new conversation)
  getChatUsers: (params) => api.get("/chat/users", { params }),

  // Conversations
  getConversations: () => api.get("/chat/conversations"),

  getConversationById: (id) => api.get(`/chat/conversations/${id}`),

  createConversation: (participantId) =>
    api.post("/chat/conversations", { participantId }),

  /** Opens or creates the platform support thread (user + all super admins). */
  ensureSupportConversation: () => api.post("/chat/support-conversation"),

  // Messages
  getMessages: (conversationId, params) =>
    api.get(`/chat/conversations/${conversationId}/messages`, { params }),

  sendMessage: (conversationId, message) => {
    if (message.file) {
      const formData = new FormData();
      if (message.content) formData.append("content", message.content);
      formData.append("chat", message.file);
      return api.post(`/chat/conversations/${conversationId}/messages`, formData);
    }
    return api.post(`/chat/conversations/${conversationId}/messages`, message);
  },

  deleteMessage: (conversationId, messageId) =>
    api.delete(`/chat/conversations/${conversationId}/messages/${messageId}`),

  // Groups
  getGroups: () => api.get("/chat/groups"),

  getGroupById: (id) => api.get(`/chat/groups/${id}`),

  createGroup: (groupData) => api.post("/chat/groups", groupData),

  updateGroup: (id, groupData) => api.put(`/chat/groups/${id}`, groupData),

  deleteGroup: (id) => api.delete(`/chat/groups/${id}`),

  addGroupMembers: (groupId, memberIds) =>
    api.post(`/chat/groups/${groupId}/members`, { memberIds }),

  removeGroupMember: (groupId, memberId) =>
    api.delete(`/chat/groups/${groupId}/members/${memberId}`),

  transferGroupAdmin: (groupId, newAdminUserId) =>
    api.post(`/chat/groups/${groupId}/transfer-admin`, { newAdminUserId }),

  promoteGroupMemberAdmin: (groupId, memberId) =>
    api.post(`/chat/groups/${groupId}/members/${memberId}/promote-admin`),

  revokeGroupMemberAdmin: (groupId, memberId) =>
    api.post(`/chat/groups/${groupId}/members/${memberId}/revoke-admin`),

  getGroupMessages: (groupId, params) =>
    api.get(`/chat/groups/${groupId}/messages`, { params }),

  sendGroupMessage: (groupId, message) => {
    if (message.file) {
      const formData = new FormData();
      if (message.content) formData.append("content", message.content);
      formData.append("chat", message.file);
      return api.post(`/chat/groups/${groupId}/messages`, formData);
    }
    return api.post(`/chat/groups/${groupId}/messages`, message);
  },

  // Community Groups
  getCommunityGroups: (params) => api.get("/chat/community-groups", { params }),

  getCommunityGroupById: (id) => api.get(`/chat/community-groups/${id}`),

  createCommunityGroup: (groupData) =>
    api.post("/chat/community-groups", groupData),

  updateCommunityGroup: (groupId, groupData) =>
    api.put(`/chat/community-groups/${groupId}`, groupData),

  deleteCommunityGroup: (groupId) =>
    api.delete(`/chat/community-groups/${groupId}`),

  joinCommunityGroup: (groupId) =>
    api.post(`/chat/community-groups/${groupId}/join`),

  leaveCommunityGroup: (groupId) =>
    api.post(`/chat/community-groups/${groupId}/leave`),

  getCommunityGroupMembers: (groupId, params) =>
    api.get(`/chat/community-groups/${groupId}/members`, { params }),

  addCommunityGroupMembers: (groupId, userIds) =>
    api.post(`/chat/community-groups/${groupId}/members`, { userIds }),

  removeCommunityGroupMember: (groupId, userId) =>
    api.delete(`/chat/community-groups/${groupId}/members/${userId}`),

  // Broadcast Groups
  getBroadcastGroups: (params) => api.get("/chat/broadcast-groups", { params }),

  getBroadcastGroupById: (id) => api.get(`/chat/broadcast-groups/${id}`),

  createBroadcastGroup: (groupData) =>
    api.post("/chat/broadcast-groups", groupData),

  updateBroadcastGroup: (groupId, groupData) =>
    api.put(`/chat/broadcast-groups/${groupId}`, groupData),

  deleteBroadcastGroup: (groupId) =>
    api.delete(`/chat/broadcast-groups/${groupId}`),

  sendBroadcastMessage: (groupId, message) =>
    api.post(`/chat/broadcast-groups/${groupId}/messages`, message),

  subscribeToBroadcast: (groupId) =>
    api.post(`/chat/broadcast-groups/${groupId}/subscribe`),

  unsubscribeFromBroadcast: (groupId) =>
    api.post(`/chat/broadcast-groups/${groupId}/unsubscribe`),

  getBroadcastGroupMembers: (groupId, params) =>
    api.get(`/chat/broadcast-groups/${groupId}/members`, { params }),

  addBroadcastGroupMembers: (groupId, userIds) =>
    api.post(`/chat/broadcast-groups/${groupId}/members`, { userIds }),

  removeBroadcastGroupMember: (groupId, userId) =>
    api.delete(`/chat/broadcast-groups/${groupId}/members/${userId}`),
};

export default chatService;
